import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/technicalSupport.png'


const _withScopeId = n => (_pushScopeId("data-v-c01864f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "floatHref" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100px","height":"100px"},
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref,onMounted   } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'customerService',
  setup(__props) {

const hoverFloat = ref(false)

const isWithinWorkingHours = (date) => {
      const day = date.getDay(); // 0 表示星期天，1 到 6 表示工作日
      const hours = date.getHours();
      const minutes = date.getMinutes();
 
      // 判断是否为工作日
      if (day === 0 || day === 6) {
        return false;
      }
      // const  hours = 14
      // const minutes = 50
      // 判断时间是否在 9:00 至 17:45 之间
      const isWithinHours = hours >= 9 && hours <= 16;
      const isWithinMinutes = minutes <= 45;

      return hours >= 9 && hours < 17 || (hours === 17 && isWithinMinutes)
    };

    onMounted(() => {
      // 创建一个script元素来加载外部聊天机器人脚本
      const script = document.createElement('script');
      script.src = 'https://chatbot.xinnet.com/embed.min.js';
      script.id = 'dify-chatbot-script';
      script.defer = true;
      
      // 将script元素添加到文档的head中
      document.head.appendChild(script);

      // 设置聊天机器人的配置
      window.difyChatbotConfig = {
        token: 'hIjmkZWTgOCuBz7z',
        baseUrl: 'https://chatbot.xinnet.com'
      };
    });



return (_ctx: any,_cache: any) => {
  return (isWithinWorkingHours(new Date()))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "float",
        onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverFloat.value = false))
      }, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
              [_vShow, hoverFloat.value]
            ])
          ]),
          _: 1
        })
      ], 32))
    : _createCommentVNode("", true)
}
}

})